import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button, Input, Breadcrumbs, Select } from '../../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { translate, formatData, getUserNameToName } from '../../../../utils/util';
import LinePickingService from '../../../../services/LinePickingService';

const QrCodeInsert = (props) => {
    const [qrCode, setqrCode] = useState(props.location?.state?.update && props.qrCode ? props.qrCode : {});
    const update = props.location?.state?.update;

    const subtitles = () => {
        return [{ icon: "mdi mdi-plus-box-outline", label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }];
    }

    useEffect(() => {
        props.getQrCodeType();
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, qrCode, setqrCode);
    };

    const redirect = () => {
        props.history.goBack();
    }

    const onConfirm = () => {
        if (validateInputsRequired("formQrCodeInsert")) {
            if (update) {
                props.update(qrCode, () => {
                    redirect();
                });
            } else {
                props.add(qrCode, () => {
                    redirect();
                });
            }
        }
    };
    
    return (
        <div>
            <Breadcrumbs id="qrCodeInsert" title={{ icon: "mdi mdi-qrcode", label: translate('qrcode', 'qrcode-picking') }} subtitles={subtitles()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div id="formQrCodeInsert" className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s12">
                                    <Select
                                        required
                                        id="qrCodeTypeId"
                                        name="qrCodeTypeId"
                                        placeHolder={translate('fields.qrcodeTypeId', 'qrcode-picking')}
                                        defaultValue={qrCode?.qrCodeTypeId || ''}
                                        data={props.qrCodeType?.items ? props.qrCodeType?.items.map((i) => { return { id: i.id, text: i.description }; }) : []}
                                        change={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input onChange={onChange} required label={translate('fields.manufactory', 'qrcode-picking')} id="manufactory " name="manufactory" type="text" defaultValue={qrCode?.manufactory} />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input onChange={onChange} required label={translate('fields.code', 'qrcode-picking')} id="qrCode" name="qrCode" type="text" defaultValue={qrCode?.qrCode} />
                                </div>
                                {update && 
                                    <div>
                                        <div className="input-field no-padding col s12">
                                            <Input required label={translate('fields.updateBy', 'qrcode-picking')} id="updateBy" name="updateBy" type="text" defaultValue={getUserNameToName(props?.usersFromElog, qrCode?.updatedBy)} disabled />
                                        </div>
                                        <div className="input-field no-padding col s12">
                                            <Input required label={translate('fields.updateOn', 'qrcode-picking')} id="updateOn" name="updateOn" type="text" defaultValue={formatData(qrCode?.updatedOn)} disabled />
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        qrCode: state.linePickingReducer.qrCode,
        qrCodeType: state.linePickingReducer.qrCodeType,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        add: (qrCode, callback) => {
            dispatch(LinePickingService.addQrCode(qrCode, callback));
        },
        update: (qrCode, callback) => {
            dispatch(LinePickingService.updateQrCode(qrCode, callback));
        },
        getQrCodeType: () => {
            dispatch(LinePickingService.getQrCodeType());
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(QrCodeInsert)));
